import React from "react";
import DialogBox from "./dialog-box";

const UploadProjectImage = ({ projectCoverImage }) => {
  return (
    <React.Fragment>
      <DialogBox projectCoverImage={projectCoverImage} />
    </React.Fragment>
  );
};

export default UploadProjectImage;
